var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M9.864 17.73a8.148 8.148 0 1 0 0-16.297 8.148 8.148 0 0 0 0 16.297Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M9.864 17.73c2.392 0 4.332-3.648 4.332-8.149s-1.94-8.148-4.332-8.148-4.332 3.648-4.332 8.148 1.94 8.149 4.332 8.149ZM1.93 6.913h15.554M1.93 12.25h15.554"
  })));
};
export default SvgGlobe;